import { IJourney } from '../../../../../../../../models/journey.model';
import { ITariffZone } from '../../../../../../../../models/tariff-zone.model';

export class ZoneIconHelper {
  static getZoneIconText({ tariffZones, journey }: { tariffZones: ITariffZone[] | undefined; journey: IJourney }): string | undefined {
    if (!tariffZones || tariffZones.length === 0) return undefined;

    // NV-6808: Only show the zone icon if the zone combination is valid
    const validZoneCombinations = ['A', 'B', 'C', 'AB', 'BC', 'ABC'];

    const anyTripLegHasDoubleZones =
      journey.tripLegs?.some(
        (leg) =>
          (leg.origin.stopPoint.stopArea?.tariffZone1 && leg.origin.stopPoint.stopArea?.tariffZone2) ||
          (leg.destination.stopPoint.stopArea?.tariffZone1 && leg.destination.stopPoint.stopArea?.tariffZone2)
      ) ?? false;
    if (anyTripLegHasDoubleZones) return undefined;

    const sortedZones = tariffZones
      .map((x) => x.shortName)
      .sort()
      .join('');

    if (!validZoneCombinations.includes(sortedZones)) {
      return undefined;
    }

    return sortedZones;
  }
}
